import app, { csl } from "@@assets/scripts/common";
import "@@components/index/contact";

app.gaAutoSendPageview = false;

app.onReady((...args) => {
	csl.log.orange(`${app.pageName} onReady`, ...args);
	
	delete app._GET.sheet;
	app.replaceState(app._GET);
});

app.exec();
